import Gumshoe from 'gumshoejs';

// Documentatie: https://github.com/cferdinandi/gumshoe

export default function () {
    var ProductMenu = document.getElementById('c-productmenu');

    if (ProductMenu !== null) {
        var spy = new Gumshoe('#c-productmenu a');
    }
}
